// Estados que guarda el backend, en palabras para la empresa. Los códigos (active, on_hold...) no
// se enseñan tal cual en el panel.

// Estado de la reserva (status), con el color de su etiqueta.
export const ESTADO_RESERVA = {
  pending: { label: "Pendiente", cls: "bg-[#E89B33]/15 text-[#9C6512]" },
  active: { label: "En curso", cls: "bg-marca/10 text-marca" },
  completed: { label: "Completada", cls: "bg-[#4A7C59]/15 text-[#2F5538]" },
  pending_payment: { label: "Pago pendiente", cls: "bg-acento/15 text-[#8C3B26]" },
  expired: { label: "Caducada", cls: "bg-[#EAE7E0] text-[#5C5C5C]" },
  cancelled: { label: "Cancelada", cls: "bg-[#EAE7E0] text-[#5C5C5C]" },
};

// Estado de la fianza (payment_status).
export const ESTADO_FIANZA = {
  pending: "Pendiente de pago",
  unpaid: "Pendiente de pago",
  on_hold: "Retenida en la tarjeta",
  paid: "Cobrada",
  captured: "Cobrada",
  hold_expired: "Retención caducada",
  released: "Liberada",
  refunded: "Devuelta",
  settled: "Liquidada",
};

// Un estado desconocido (de una versión nueva del backend) se enseña tal cual antes que perderlo.
export const estadoReserva = (s) => ESTADO_RESERVA[s]?.label || s || "—";
export const estadoFianza = (s) => ESTADO_FIANZA[s] || s || "—";
